import './paypage.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';

// ✅ استخدام متغير البيئة مع قيمة افتراضية
const API_URL = process.env.REACT_APP_API_URL;

export default function Paypage({ cartlist, setcartlist }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        whatsapp: ''
    });
    const [isOrderSubmitted, setIsOrderSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    useEffect(() => {
        const savedName = localStorage.getItem('customer_name') || '';
        const savedAddress = localStorage.getItem('customer_address') || '';
        const savedPhone = localStorage.getItem('customer_phone') || '';
        const savedWhatsapp = localStorage.getItem('customer_whatsapp') || '';
        setFormData({
            name: savedName,
            address: savedAddress,
            phone: savedPhone,
            whatsapp: savedWhatsapp
        });
    }, []);

    useEffect(() => {
        if (formData.name.trim() !== '') {
            localStorage.setItem('customer_name', formData.name);
        }
        if (formData.address.trim() !== '') {
            localStorage.setItem('customer_address', formData.address);
        }
        if (formData.phone.trim() !== '') {
            localStorage.setItem('customer_phone', formData.phone);
        }
        if (formData.whatsapp.trim() !== '') {
            localStorage.setItem('customer_whatsapp', formData.whatsapp);
        }
    }, [formData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // حساب المجموع الكلي للطلب
    const calculateTotal = () => {
        return cartlist.reduce((total, item) => {
            const price = parseFloat(String(item.price || '0').replace(/[^\d.]/g, '')) || 0;
            return total + (price * (item.quantity || 1));
        }, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.address || !formData.phone || !formData.whatsapp) {
            alert(t('requiredField'));
            return;
        }

        if (cartlist.length === 0) {
            alert('السلة فارغة');
            return;
        }

        // بناء بيانات الطلب
        const orderData = {
            customerdata: {
                name: formData.name,
                address: formData.address,
                phone: formData.phone,
                whatsapp: formData.whatsapp,
                orderDate: new Date().toISOString()
            },
            cartdata: cartlist.map(item => ({
                id: item.id,
                name: item.name,
                price: item.price,
                color: item.color || '',
                size: item.size || '',
                quantity: item.quantity || 1,
                totalPrice: (parseFloat(String(item.price || '0').replace(/[^\d.]/g, '')) * (item.quantity || 1)).toFixed(2)
            })),
            totalOrderPrice: calculateTotal().toFixed(2)
        };

        setIsSubmitting(true);
        setSubmitMessage('');

        try {
            // ✅ إرسال البيانات إلى Backend عبر الرابط الصحيح
            const response = await fetch(`${API_URL}/orders`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(orderData),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error ${response.status}`);
            }

            // نجاح الإرسال
            setIsOrderSubmitted(true);
            setSubmitMessage('✅ تم اتمام عملية الشراء بنجاح!');

            // حفظ الطلب محلياً كنسخة احتياطية
            try {
                const existingOrders = JSON.parse(localStorage.getItem('orders') || '[]');
                existingOrders.push(orderData);
                localStorage.setItem('orders', JSON.stringify(existingOrders));
                localStorage.setItem('last_order', JSON.stringify(orderData));
            } catch (localError) {
                console.warn('Could not save order locally:', localError);
            }

            // تفريغ السلة
            setcartlist([]);
            localStorage.removeItem('cart');

            // إخفاء رسالة النجاح بعد 5 ثواني
            setTimeout(() => {
                setSubmitMessage('');
            }, 5000);

        } catch (error) {
            console.error('Error submitting order:', error);
            setSubmitMessage('❌ فشل إرسال الطلب: ' + error.message);
            alert('حدث خطأ أثناء إرسال الطلب: ' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="pay-page">
            <div className='note'>
                <p>{t('cashOnDelivery')}</p>
            </div>
            <div className='form'>
                <form onSubmit={handleSubmit}>
                    <label>{t('fullName')}</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder={t('enterFullName')}
                        required
                        disabled={isOrderSubmitted || isSubmitting}
                    />
                    <label>{t('address')}</label>
                    <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        placeholder={t('enterAddress')}
                        required
                        disabled={isOrderSubmitted || isSubmitting}
                    />
                    <label>{t('phone')}</label>
                    <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder={t('enterPhone')}
                        required
                        disabled={isOrderSubmitted || isSubmitting}
                    />
                    <label>{t('whatsapp')}</label>
                    <input
                        type="tel"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleInputChange}
                        placeholder={t('enterWhatsapp')}
                        required
                        disabled={isOrderSubmitted || isSubmitting}
                    />
                    <div className='form-submit'>
                        <button
                            type="submit"
                            className={`input-submit ${isOrderSubmitted ? 'submitted' : ''}`}
                            disabled={isOrderSubmitted || isSubmitting || cartlist.length === 0}
                        >
                            {isSubmitting ? 'جاري الإرسال...' :
                                isOrderSubmitted ? t('orderCompleted') : t('completePurchase')}
                        </button>
                    </div>
                    {submitMessage && (
                        <div className="submit-message" style={{
                            textAlign: 'center',
                            margin: '10px 0',
                            color: isOrderSubmitted ? 'green' : 'red',
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}>
                            {submitMessage}
                        </div>
                    )}
                </form>
            </div>
            <div className='go'>
                <div className='go-text'>
                    <p>{t('goToHomePage')}</p>
                </div>
                <div className='go-button'>
                    <Link to="/">
                        <button>{t('go')}</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}